import ListAtmPayRollDetailsUpdate from "./ListAtmPayRollDetailsUpdate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAtmDetails } from "../../../../../store/Api";

export default function AtmPayRollDetailsUpdate({ setIndex }) {
  const data = useSelector((state) => state.getAtmDetails);
  useEffect(() => {
    dispatch(getAtmDetails(token));
  }, []);

  const updateData = () => {
    dispatch(getAtmDetails(token));
  };

  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  return (
    <ListAtmPayRollDetailsUpdate
      titles={[
        "S.NO.",
        "EMPLOYEE ID",
        "EMPLOYEE NAME",
        "CLIENT",
        "VISA PROVIDER",
        "IQAMA NUMBER",
        "IQAMA EXPIRY DATE (G)",
        "IQAMA EXPIRY DATE (H)",
        "EMPLOYEE KSA CONTACT NUMBER",
        "ACCOUNT TO BE OPENED BY",
        "FEE",
        "Payment Status",
        "Bank Name",
        "Account Number",
        "IBAN NUMBER",
        "ATM CARD NUMBER",
        "ATM CARD EXPIRY",
        "status",
      ]}
      list={data}
      loading={loading}
      token={token}
      updateData={updateData}
      setIndex={setIndex}
    />
  );
}
